var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.25 13.75C6.25 9.61375 9.61375 6.25 13.75 6.25C17.8862 6.25 21.25 9.61375 21.25 13.75C21.25 17.8862 17.8862 21.25 13.75 21.25C9.61375 21.25 6.25 17.8862 6.25 13.75ZM25.8838 24.1162L21.64 19.8713C22.9563 18.1788 23.75 16.0575 23.75 13.75C23.75 8.23625 19.2638 3.75 13.75 3.75C8.23625 3.75 3.75 8.23625 3.75 13.75C3.75 19.2638 8.23625 23.75 13.75 23.75C16.0575 23.75 18.1788 22.9563 19.8713 21.64L24.1162 25.8838C24.36 26.1275 24.68 26.25 25 26.25C25.32 26.25 25.64 26.1275 25.8838 25.8838C26.3725 25.395 26.3725 24.605 25.8838 24.1162Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.b6da6116c7e2c24e9fc4aa7b5275965d.svg";
export { ForwardRef as ReactComponent };